import { createContext } from "react";

// The context that handles the app's global theme.
const ThemeContext = createContext();

export default ThemeContext;